import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Layout() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <Navbar />
      <main className={`flex-1 ${isHome ? '' : 'pt-16 md:pt-[72px]'}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}